import store from "@/store";
import {ACT_DOWNLOAD_DEPT_REQ_TRAIN_ATCH} from "@/store/modules/dept/dept";

export const downloadDeptReqAtch = (key, fileNm) => {
    store.dispatch(`dept/${ACT_DOWNLOAD_DEPT_REQ_TRAIN_ATCH}`, {deptReqFileAtchSn: key, fileName: fileNm});
};
